import { Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PObject } from '../../../../../models/object';
import { WidgetMapRegion } from '../../../../../models/widget';

export interface RegionAndEntity {
  region: WidgetMapRegion;
  entity: PObject;
}

@Component({
  selector: 'cw-editor-object-list-item',
  templateUrl: './editor-object-list-item.component.html',
  styleUrls: ['./editor-object-list-item.component.scss']
})

export class EditorObjectListItemComponent implements OnInit, OnChanges {
  @Input() object: PObject;
  @Input() objects: PObject[];
  @Input() region: WidgetMapRegion;
  @Input() selected: boolean;
  @Output() draw: EventEmitter<void> = new EventEmitter<void>();
  @Output() deleteRegion: EventEmitter<void> = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  doDraw() {
    this.draw.emit();
  }

  doDeleteRegion() {
    this.deleteRegion.emit();
  }

  @HostBinding('class')
  get className() {
    const classNames = ['list-group-item', 'me-object-list-item'];

    if (this.selected) {
      classNames.push('is-selected');
    }

    if (this.region) {
      classNames.push('has-region');
    }

    return classNames.join(' ');
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/widget-detail/map-editor/editor-object-list/editor-object-list-item/editor-object-list-item.component.ts